import React from 'react';
import { StripeProvider, Elements } from 'react-stripe-elements';

import { Loading } from '@dom/components';
 
import config from '@dom/config';
import { promisifyScript } from '@dom/utils';

const STRIPE_SCRIPT_URL = 'https://js.stripe.com/v3/';

/**
 * This component loads Stripe script before our application code.
 * The Stripe script loads the stripe instance which can be used as a prop to the Stripe Provider
 */

export default function StripeLoaderContainer(props) {
  const [stripe, setStripe] = React.useState(null);
  const [error, setError] = React.useState(null);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    if (window.Stripe) {
      setStripe(window.Stripe(config.stripe));
      setLoading(false);

      return;
    }

    promisifyScript(STRIPE_SCRIPT_URL)
      .then(() => setStripe(window.Stripe(config.stripe)))
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  // put a button here to reload the page
  if (error) {
    return <p>{error} Please refresh this page</p>;
  }

  if (loading) {
    return <Loading />;
  }

  return (
    <StripeProvider stripe={stripe}>
      <Elements {...props}/>
    </StripeProvider>
  );
}
